import { render } from "./Lab.vue?vue&type=template&id=e50144b0"
import script from "./Lab.vue?vue&type=script&lang=js"
export * from "./Lab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__